import { MappingExport } from '@pubstack/common/src/mappingExport'
import { AdminScope } from '@pubstack/common/src/scope'
import { MutationToasts, useMutation, useQuery } from '~/api/api-client'

export const MAPPING_EXPORTS_QUERY_KEYS = ['mapping-exports']

//-------------------------------------------------------------------------
// Queries
//-------------------------------------------------------------------------
export const useMappingExport = (scopeId: AdminScope['id'], siteId: string, mappingExportId?: string) => {
  return useQuery<MappingExport>({
    url: `/admin/scopes/${scopeId}/sites/${siteId}/mapping-exports/${mappingExportId}`,
    keys: [...MAPPING_EXPORTS_QUERY_KEYS, mappingExportId ?? ''],
    enabled: !!mappingExportId,
  })
}

export const useMappingExports = (scopeId: AdminScope['id'], siteId: string) => {
  const queryResult = useQuery<MappingExport[]>({ url: `/admin/scopes/${scopeId}/sites/${siteId}/mapping-exports`, keys: MAPPING_EXPORTS_QUERY_KEYS, enabled: !!scopeId && !!siteId })

  return { ...queryResult, data: queryResult.data || [] }
}

//-------------------------------------------------------------------------
// Mutations
//-------------------------------------------------------------------------
export const useCreateMappingExport = (scopeId: AdminScope['id'], siteId: string, toasts: MutationToasts = {}) => {
  return useMutation<MappingExport>({
    method: 'post',
    url: `/admin/scopes/${scopeId}/sites/${siteId}/mapping-exports`,
    collectionKeys: MAPPING_EXPORTS_QUERY_KEYS,
    ...toasts,
  })
}
